<div class="calendar-navigations">
    <h4 class="calendar-month">{{ monthTitle() }}</h4>
    <div class="calendar-month-nav align-center">
        <mat-icon (click)="prevMonth()" [class.disabled]="isPrevDisabled()">keyboard_double_arrow_left</mat-icon>
        <div class="circle" (click)="goToCurrentMonth()"></div>
        <mat-icon (click)="nextMonth()" [class.disabled]="isNextDisabled()">keyboard_double_arrow_right</mat-icon>
    </div>
</div>
